/* eslint-disable listeners/no-missing-remove-event-listener */
const customSliderClass = 'the-home-custom-slider';
const scrollProgressClass = `${customSliderClass}__scrollbar-progress`;
const scrollHoverClass = `${customSliderClass}__scroll-hover`;
const scrollHoverLeftClass = `${scrollHoverClass}--left`;
const scrollHoverRightClass = `${scrollHoverClass}--right`;
const scrollHoverHiddenClass = `${scrollHoverClass}--hidden`;
const animationClassName = 'the-home-animations';
const animationClassNameActive = `${animationClassName}--active`;
const getCustomSliders = (ele) => ele.querySelectorAll(`.${customSliderClass}`);
const getScrollProgressBar = (ele) =>
  ele.querySelector(`.${scrollProgressClass}`);
const getScrollHover = (ele) => ele.querySelectorAll(`.${scrollHoverClass}`);
const getScrollHoverLeft = (ele) =>
  ele.querySelector(`.${scrollHoverLeftClass}`);
const getScrollHoverRight = (ele) =>
  ele.querySelector(`.${scrollHoverRightClass}`);
const { forEachElement } = require('../../common/utils/dom');

/**
 * Inits custom-slider element
 */
const initCustomSlider = (ele) => {
  const slider = ele.firstElementChild;

  if (slider.dataset.initialized) return;

  slider.dataset.initialized = true;
  const options = JSON.parse(ele.dataset.options || {});
  if (options.autoplay === '0') {
    options.autoplay = false;
  }
  const progressBar = getScrollProgressBar(ele);
  const setProgressBar = () => {
    const maxScroll = slider.scrollWidth - slider.offsetWidth;
    const currentScroll = (slider.scrollLeft / maxScroll) * 100;
    progressBar.style.width = `${currentScroll}%`;
  };
  setProgressBar();
  let isDown = false;
  let startX;
  let scrollLeft;

  const handleMouseDown = (e) => {
    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    if (slider.dataset.eventScroll) delete slider.dataset.eventScroll;
  };
  const handleMouseLeave = () => {
    isDown = false;
  };
  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    slider.dataset.eventScroll = true;
    const x = e.pageX - slider.offsetLeft;
    const walk = x - startX;
    slider.scrollLeft = scrollLeft - walk;
  };
  const handleClick = (e) => {
    if (slider.dataset.eventScroll) e.preventDefault();
  };
  const handleScroll = () => {
    setProgressBar();
    // remove animations on interaction with slider
    ele?.classList?.remove(animationClassName, animationClassNameActive);
  };
  slider.addEventListener('mousedown', handleMouseDown);
  slider.addEventListener('mouseleave', handleMouseLeave);
  slider.addEventListener('mouseup', handleMouseLeave);
  slider.addEventListener('mousemove', handleMouseMove);
  slider.addEventListener('click', handleClick);
  slider.addEventListener('scroll', handleScroll);

  if (options?.scrollHover === true) {
    const scrollHoverLeft = getScrollHoverLeft(ele);
    const scrollHoverRight = getScrollHoverRight(ele);
    const scrollHovers = getScrollHover(ele);
    const scrollHoverDistance = options.scrollHoverDistance
      ? options.scrollHoverDistance
      : 200;
    const scrollHoverTime = options.scrollHoverTime
      ? options.scrollHoverTime / scrollHoverDistance
      : 1000 / scrollHoverDistance;
    let intervalScrollHovers;
    const eventScrollHovers = ({ target }) => {
      let valueScroll = 0;
      if (target === scrollHoverLeft) valueScroll = -1;
      if (target === scrollHoverRight) valueScroll = 1;
      intervalScrollHovers = setInterval(() => {
        slider.scrollLeft += valueScroll;
      }, scrollHoverTime);
    };
    const eventScrollHoversLeave = () => {
      clearTimeout(intervalScrollHovers);
    };

    forEachElement(scrollHovers, (scrollHover) => {
      scrollHover.addEventListener('mouseenter', eventScrollHovers);
      scrollHover.addEventListener('mouseleave', eventScrollHoversLeave);
    });

    const hiddenScrollHover = () => {
      const maxScroll = slider.scrollWidth - slider.offsetWidth;
      scrollHoverLeft.classList.remove(scrollHoverHiddenClass);
      scrollHoverRight.classList.remove(scrollHoverHiddenClass);
      if (slider.scrollLeft <= 0) {
        scrollHoverLeft.classList.add(scrollHoverHiddenClass);
      } else if (slider.scrollLeft >= maxScroll) {
        scrollHoverRight.classList.add(scrollHoverHiddenClass);
      }
    };

    hiddenScrollHover();
    slider.addEventListener('scroll', hiddenScrollHover);
  }
};

/**
 * Init custom slider components
 */
export default function initCustomSliders() {
  forEachElement(getCustomSliders(document), initCustomSlider);
}
